import { defineStore } from "pinia";
import { ref } from "vue";

export const useNotificationConfig = defineStore("notificationConfig", () => {
  const notificationConfig = ref([]);
  const query = ref(null);

  return { notificationConfig, query };
});
